// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "content/" + "administration" + "." + "60f48c2796b285564e98" + ".css";
};